import {getErrorMessage} from '@yandex-delivery/utils'

import type {AddNotification, CustomNotification} from './types'

let id = 0

/** Создаёт независимую очередь для приложения, провайдера или теста. */
export const createNotificationStore = () => {
  let notifications: readonly CustomNotification[] = []
  const listeners = new Set<VoidFunction>()

  const notify = () => {
    for (const listener of [...listeners]) {
      listener()
    }
  }

  const add: AddNotification = (msg, notificationConfig) => {
    const message = msg instanceof Error ? getErrorMessage(msg) : msg
    const type = msg instanceof Error ? 'error' : notificationConfig?.type
    const newNotification: CustomNotification = {
      ...notificationConfig,
      type: type ?? 'success',
      msg: message,
      id: ++id,
    }

    notifications = [...notifications, newNotification]
    notify()
  }

  const clear = () => {
    if (notifications.length === 0) return

    notifications = []
    notify()
  }

  const getSnapshot = () => notifications

  const remove = (itemId: CustomNotification['id']) => {
    const nextNotifications = notifications.filter(({id}) => id !== itemId)
    if (nextNotifications.length === notifications.length) return

    notifications = nextNotifications
    notify()
  }

  const subscribe = (listener: VoidFunction): VoidFunction => {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }

  return {add, clear, getSnapshot, remove, subscribe}
}

export type NotificationStore = ReturnType<typeof createNotificationStore>
